<script setup lang="ts">
/**
 * 템플릿 [[if flag]]…[[else]]…[[endif]] 를 문서 안에서 켜고 끄는 블록 — 상단 옵션 바 대신 해당 문단 자리에서 바로 토글.
 *   · 켜짐: 본문(default slot)
 *   · 꺼짐: #else 슬롯이 있으면 그 문장, 없으면 본문을 흐리게(생성 안 됨) 보여 준다.
 *   같은 flag 는 모델 공유라 한 문서에서 바꾸면 다른 문서도 같이 바뀐다.
 */
import { computed, useSlots } from 'vue';
import { useAgmStudio } from './agmStudioContext';

const props = defineProps<{ flag: string; label: string }>();
const { model } = useAgmStudio();
const slots = useSlots();
const on = computed(() => !!model[props.flag]);
function toggle() { model[props.flag] = !on.value; }
</script>

<template>
  <div class="agm-cond" :class="{ off: !on && !slots.else }">
    <button type="button" class="agm-cond-tg" :class="{ on }" :title="on ? 'Click to remove from the documents' : 'Click to include in the documents'" @click="toggle">
      {{ on ? '☑' : '☐' }} {{ label }}
    </button>
    <div v-if="on" class="agm-cond-body"><slot /></div>
    <div v-else-if="slots.else" class="agm-cond-body"><slot name="else" /></div>
    <div v-else class="agm-cond-body dim" aria-hidden="true"><slot /></div>
  </div>
</template>

<style scoped>
.agm-cond { position: relative; margin: 6px 0; padding-left: 8px; border-left: 3px solid #bfe6cf; }
.agm-cond.off { border-left-color: #d7dde8; }
.agm-cond-tg { border: 1px solid #bfe6cf; background: #eafaf1; color: #14713f; font-size: 10.5px; font-weight: 700; border-radius: 999px; padding: 0 8px; line-height: 18px; cursor: pointer; font-family: inherit; }
.agm-cond-tg:not(.on) { border-color: #d7dde8; background: #f4f6fa; color: #6b7a94; }
.agm-cond-body.dim { opacity: 0.35; pointer-events: none; user-select: none; }
</style>
